import { ApiProperty } from '@nestjs/swagger';
import { Exclude, Expose, Type } from 'class-transformer';
import {
  MarkAsPaidSummaryContractorInterface,
  MarkAsPaidSummaryInterface,
  MarkAsPaidSummaryLineInterface,
} from '../interfaces/mark-as-paid-summary.interface';

@Exclude()
export class MarkAsPaidSummaryLineDto
  implements MarkAsPaidSummaryLineInterface
{
  @ApiProperty({
    type: 'string',
    title: 'Type',
    description:
      'Prod Payables MS: the phase or option line as the Accounting Report names it. Bumpout Timesheet: the Repair Type column.',
  })
  @Expose()
  type!: string;

  @ApiProperty({
    type: 'number',
    title: 'Amount',
    description:
      'Sum of the selected rows of this contractor and type, in dollars.',
  })
  @Expose()
  amount!: number;
}

@Exclude()
export class MarkAsPaidSummaryContractorDto
  implements MarkAsPaidSummaryContractorInterface
{
  @ApiProperty({ type: 'string', title: 'Contractor name' })
  @Expose()
  contractorName!: string;

  @ApiProperty({
    type: 'number',
    title: 'Amount',
    description: 'Sum of every selected row of this contractor, in dollars.',
  })
  @Expose()
  amount!: number;

  @ApiProperty({
    type: MarkAsPaidSummaryLineDto,
    isArray: true,
    title: 'Lines',
    description: "The contractor's amount split by type of work, types A to Z.",
  })
  @Expose()
  @Type(() => MarkAsPaidSummaryLineDto)
  lines!: MarkAsPaidSummaryLineDto[];
}

/**
 * Answer of the *-paid batch `summary` endpoints: the contractor table shown
 * in the Mark as Paid confirmation prompt.
 */
@Exclude()
export class MarkAsPaidSummaryDto implements MarkAsPaidSummaryInterface {
  @ApiProperty({
    type: MarkAsPaidSummaryContractorDto,
    isArray: true,
    title: 'Contractors',
    description:
      'One entry per contractor with at least one selected row, A to Z.',
  })
  @Expose()
  @Type(() => MarkAsPaidSummaryContractorDto)
  contractors!: MarkAsPaidSummaryContractorDto[];

  @ApiProperty({
    type: 'number',
    title: 'Grand Total',
    description: 'Sum of every contractor amount, in dollars.',
  })
  @Expose()
  grandTotal!: number;

  @ApiProperty({
    type: 'boolean',
    title: 'Has paid rows',
    description:
      'True when at least one selected row is already marked as paid.',
  })
  @Expose()
  hasPaidRows!: boolean;

  @ApiProperty({
    type: 'number',
    title: 'Row count',
    description: 'Number of selected rows the summary covers.',
  })
  @Expose()
  rowCount!: number;
}
